export default __webpack_public_path__ + "static/caption-03-en-afd57c3147bafb7f24f67f614d444313.png";